import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const RemoveFavModal = props => {
  const { onCancelHandler, onRemoveHandler } = props;
  const { REMOVE, CANCEL, REMOVE_FROM_FAVMODAL_MSG } = TRANSLATE_MAPPING_KEY;
  return (
    <div className='remove-from-favorite-orders-modal'>
      <div className='remove-message-section'>
        <p className='remove-message'>{translateWithI18Next(REMOVE_FROM_FAVMODAL_MSG)}</p>
      </div>
      <div className='buttonItems remove-from-fav-modal-btns'>
        <ButtonComp
          data-testid='cancel-remove-favOrders'
          className='button whiteButton blackBorder closebtn-cls'
          onClickHandler={onCancelHandler}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          data-testid='yes-keep-it-btn'
          className='button blackButton blackBorder save-button'
          onClickHandler={onRemoveHandler}
        >
          {translateWithI18Next(REMOVE)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default RemoveFavModal;
